import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
// import { HambergerMenu } from 'iconsax-react';

// project-imports
import Drawer from './Drawer';
// import Footer from './Footer';
import HorizontalBar from './Drawer/HorizontalBar';

import Breadcrumbs from 'components/@extended/Breadcrumbs';
import AuthGuard from 'utils/route-guard/AuthGuard';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'types/config';
import ClientInitializer from 'components/ClientInitializer';
import PersistentCallOverlay from 'components/PersistentCallOverlay';
import CallMessageAlert from 'components/CallMessageAlert';
import CallUserDialog from 'components/CallUserDialog';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();

  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { container, menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // if (menuMasterLoading) return <Loader />;

  return (
    <AuthGuard>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <PersistentCallOverlay />
        <CallMessageAlert />
        <CallUserDialog />
        {/* <Header /> */}
        {/* <VideoCallAlert /> */}
        {!isHorizontal ? <Drawer /> : <HorizontalBar />}
        {/* minWidth 0 lets this shrink as the rail expands, instead of overflowing the row */}
        <Box component="main" sx={{ flexGrow: 1, minWidth: 0, p: { xs: 2, md: 3 } }}>
          
          <Container
            maxWidth={container ? 'xl' : false}
            sx={{
              xs: 0,
              ...(container && { px: { xs: 0, md: 2 } }),
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Breadcrumbs />
            <ClientInitializer />
            <Outlet />
            {/* <Footer /> */}
          </Container>
        </Box>
      </Box>
    </AuthGuard>
  );
};

export default MainLayout;
